<template>
    <div class="">
        <div @click="openModal" class="cursor-pointer">
            <slot></slot>
        </div>
        <d-modal
            v-if="isModalOpen"
            @close="handleClose"
            centered
        >
            <d-modal-header>
                <d-modal-title>
                    {{ title }}
                </d-modal-title>
            </d-modal-header>
            <d-modal-body>
                <p v-if="message" class="fz-normal text-left">
                    {{ message }}
                </p>
                <div class="d-flex align-items-center">
                    <d-button
                        @click="confirm"
                        class="mr-1"
                        block-level
                        theme="danger"
                    >
                        {{ deleteButtonText }}
                    </d-button>
                    <d-button
                        @click="handleClose"
                        class="ml-1 mt-0"
                        block-level
                        theme="success"
                    >
                        {{ keepButtonText }}
                    </d-button>
                </div>
            </d-modal-body>
        </d-modal>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            required: false,
            default: 'Are you sure?'
        },
        message: {
            required: false,
            default: ''
        },
        deleteButtonText: {
            required: false,
            default: 'Yes, delete'
        },
        keepButtonText: {
            required: false,
            default: 'No, keep'
        },
    },
    data() {
        return {
            isModalOpen: false,
        }
    },
    methods: {
        confirm() {
            this.$emit('confirm');
        },
        openModal() {
            this.isModalOpen = true;
        },
        handleClose() {
            this.isModalOpen = false;
        }
    }
}
</script>
